import { Button } from '@mui/material';
import { awaitAllSafely } from '@vy/utils';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntegrationContextProvider } from '../../../../hooks/use-integration-context-provider';
import { AnrokConfigurationControl, AnrokConfigurationFormValues } from '../AnrokConfigurationFormSchema';
import { useFetchAnrokSettings } from '../hooks/useFetchAnrokSettings';
import { useModifyConfiguration } from '../hooks/useModifyConfiguration';
import { getAnrokIntegrationSettings } from './utils';

type AnrokConfigurationFooterProps = {
  control: AnrokConfigurationControl;
};

export const AnrokConfigurationFooter: FC<AnrokConfigurationFooterProps> = () => {
  const { integrationId } = useFetchAnrokSettings();
  const updateAnrokConfiguration = useModifyConfiguration();
  const { clearSelectedIntegration } = useIntegrationContextProvider();

  const {
    handleSubmit,
    formState: { dirtyFields },
    reset,
  } = useFormContext<AnrokConfigurationFormValues>();

  const {
    apiKey: isApiKeyDirty,
    defaultExternalProductId: isDefaultExternalProductIdDirty,
    defaultTaxMethod: isDefaultTaxMethodDirty,
  } = dirtyFields;

  const getUpdateAnrokConfigurationPromise = async (formValues: AnrokConfigurationFormValues) => {
    if (!isDefaultExternalProductIdDirty && !isApiKeyDirty && !isDefaultTaxMethodDirty) {
      return undefined;
    }

    const updatedIntegrationSettings = getAnrokIntegrationSettings(formValues);

    return updateAnrokConfiguration(integrationId, updatedIntegrationSettings);
  };

  const submitHandler = handleSubmit(async (formValues) => {
    const updateAnrokConfigurationPromise = getUpdateAnrokConfigurationPromise(formValues);

    await awaitAllSafely(updateAnrokConfigurationPromise);

    reset(formValues);

    clearSelectedIntegration();
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained" onClick={submitHandler}>
        Save Configuration
      </Button>
    </div>
  );
};
